const usernameMap = new Map<string, string>([
  ['bill_wade', 'BW'],
  ['brlewis', 'BRL'],
  ['christopher.scordato', 'CS'],
  ['lbrownson', 'LB'],
  ['mmcguin', 'MG'],
  ['fabrizio', 'FMK'],
  ['abraao', 'AAH'],
  ['gobadare', 'GOB'],
  ['vromano', 'VR'],
  ['oroy', 'ORO'],
  ['mcavazos', 'MC'],
  ['jmiller', 'JM'],
  ['dtrindade', 'DT'],
  ['traci', 'TRA']
])

const reverseUsernameMap = new Map<string, string>(
  Array.from(usernameMap.entries()).map(([key, value]) => [value, key])
)

export const getShortUsername = (username: string): string => {
  return usernameMap.get(username) ?? username
}

export const getFullUsername = (shortUsername: string): string => {
  return reverseUsernameMap.get(shortUsername) ?? shortUsername
}
